import React, { useEffect } from "react";
export const iframeRef = React.createRef<HTMLIFrameElement>();

const UpIcon: React.FC = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1200);
  }, []);

  return (
    <>
      <div className="noticeIframe">
        <iframe
          ref={iframeRef}
          src="https://www.maruetsu.co.jp/app/app_waoncoupon0723.html"
        />
      </div>
    </>
  );
};

export const norticeReloadIframe = () => {
  if (iframeRef.current) {
    iframeRef.current.src += "";
  }
};

export default UpIcon;
